import { render, staticRenderFns } from "./NavBtns.vue?vue&type=template&id=00fced86&"
import script from "./NavBtns.vue?vue&type=script&lang=js&"
export * from "./NavBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports